import React from 'react';
import useIPWhitelist from '../../../Hooks/useIPWhitelist';
import usePaginatedList from '../../../Hooks/usePaginatedList';
import styles from './IPWhitelist.module.less';

const IPWhitelist = () => {
  const { loading, whitelist, enabled } = useIPWhitelist();

  const { items, totalPages, currentPage, visiblePages, isFirst, isLast, goToPage, goToNextPage, goToPreviousPage } =
    usePaginatedList(whitelist);

  if (loading || !whitelist.length || !enabled) {
    return null;
  }

  return (
    <div>
      <div className={styles.header}>{gettext('IP Allowlist')}</div>
      <p className={styles.text}> Here is the list of IP addresses that have access to your API products.</p>
      <p className={styles.text}>
        To edit the list, please contact your account manager or our
        <a href="https://pipl.com/customer-support"> customer support</a>.
      </p>
      <div className={styles.whitelist}>
        {items.map((item) => (
          <div key={item}>{item}</div>
        ))}
        {totalPages > 1 && (
          <div className={styles.pageNavigation}>
            <button
              className={[styles.pageNumber, isFirst ? styles.disabled : ''].join(' ')}
              type="button"
              onClick={goToPreviousPage}
              disabled={isFirst}
            >
              {'<'}
            </button>
            {visiblePages.map((page) => (
              <button
                type="button"
                key={page}
                onClick={goToPage(page)}
                className={[styles.pageNumber, page === currentPage ? styles.current : ''].join(' ')}
              >
                {page}
              </button>
            ))}
            <button
              type="button"
              onClick={goToNextPage}
              className={[styles.pageNumber, isLast ? styles.disabled : ''].join(' ')}
              disabled={isLast}
            >
              {'>'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default IPWhitelist;
